import React from 'react'
import { makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(theme=>({
    textField: { background: 'white' , border: 'none', boxShadow: 0,
    "&& :hover": {background: theme.palette.grey[100]},
    "&& input[type=number]":{
        textAlign: "right",
        width: "100%",
        paddingRight: 0, paddingLeft:0, marginRight: 0, marginLeft: 0  
    },
    "&& input[type=text]":{
        textAlign: "center",
        width: "100%",
        paddingRight: 0, paddingLeft:0, marginRight: 0, marginLeft: 0  
    },
    "&& input[type=date]":{
        textAlign: "center",
        width: "100%",
        paddingRight: 0, paddingLeft:0, marginRight: 0, marginLeft: 0  
    }
},
    input: { fontWeight: 400, fontSize: '0.8rem',  borderRadius:0, },
    inputLabel: { fontSize: '0.8rem'}
}))

const FunkyInput = props => {


    const classes = useStyles()
    return <TextField 
            style = {{height: "auto"}}
            variant = "outlined"
            size = "small"
            fullWidth = {props.fullWidth || true}
            className = {classes.textField}
            
            InputProps = {{className: classes.input}} 
            InputLabelProps = {{className: classes.inputLabel}}
            {...{...props, value: props.value || '' }}
            disabled = {props.disabled}
            
            /> 
    
}

export default FunkyInput